import Vue from 'vue';
import confirm from './index.vue';
let confirmConstructor = Vue.extend(confirm);

// let structureModal = (o) => {
//   let tipsCom = new tipsConstructor({
//     el: document.createElement('div') //将Alert组件挂载到新创建的div上 
//   })
//   document.body.appendChild(tipsCom.$el); //把Alert组件的dom添加到body里 


//   // 标题
//   tipsCom.title = o.title || '审批';
//   // 会议ID
//   tipsCom.meetingId = o.meetingId;
//   // taskID
//   tipsCom.taskId = o.taskId;
//   // userId
//   tipsCom.userId = o.userId;
//   // 确定-取消
//   tipsCom.a_confirm = o.confirm || null;
//   tipsCom.a_cancel = o.cancel || null;
// }
let theConfirm = function (params) {
  return new Promise((res, rej) => { //promise封装，ok执行resolve，no执行rejectlet
    let confirmDom = new confirmConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(confirmDom.$el);  //new一个对象，然后插入body里面
    confirmDom.params = Object.assign({}, confirmDom.params, params);   //为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
    confirmDom.confirm = function () {
      // console.log(confirmDom)
      confirmDom.params.dialogVisible = false;
      // console.log(confirmDom.formda)
      if (confirmDom.formData) res(confirmDom.formData)
      else res()
    }
    confirmDom.cancel = function () {
      // console.log("点击的取消")
      confirmDom.params.dialogVisible = false;
      rej("取消")
    }
    confirmDom.handleClose = function () {
      // console.log("关闭")
      confirmDom.params.dialogVisible = false;
      rej("取消")
    }

  })
}

export default theConfirm;